export default "__VITE_ASSET__D0Manx$F__"